import * as Actions from "../actions/ActionTypes";

/**
 * Stripe slice — currently just the Connect payout-onboarding status. Client
 * secrets (PaymentIntent/SetupIntent) are deliberately NOT stored here; they are
 * ephemeral and consumed by a per-flow <Elements> mount, never persisted.
 */
const StripeReducer = (
  state = {
    connectStatus: {},
  },
  action
) => {
  if (action.type == Actions.SET_STRIPE_CONNECT_STATUS) {
    return Object.assign({}, state, {
      connectStatus: action?.data,
    });
  } else {
    return state;
  }
};

export default StripeReducer;
